import { MapPin, Clock, Navigation, Instagram } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { useSettings, fullAddress, MAP_COORDS, MAP_LINK } from "../lib/site";

export const SocialLinks = ({ s, className = "" }) => {
  const items = [["instagram", "Instagram", Instagram]];
  return (
    <div className={`flex gap-3 ${className}`} data-testid="social-links">
      {items.map(([k, label, Icon]) => {
        const url = s[k];
        return (
          <a key={k} data-testid={`social-link-${k}`} href={url || undefined} target="_blank" rel="noreferrer" aria-label={label} title={url ? label : `${label} — in arrivo`}
            className={`grid h-12 w-12 place-items-center rounded-full border border-current/20 transition-[background-color,color,transform] duration-300 ${url ? "hover:-translate-y-1 hover:bg-[var(--gold)] hover:text-[var(--ink)]" : "pointer-events-none opacity-40"}`}>
            <Icon className="h-5 w-5" size={18} />
          </a>
        );
      })}
    </div>
  );
};

export const Location = () => {
  const s = useSettings();
  const q = MAP_COORDS;
  return (
    <section id="dove" data-testid="location-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionHead num="05" eyebrow="Dove siamo" title={<>Ti aspettiamo a <em className="gold-text italic">Frascati</em></>} />
        <div className="mt-14 grid gap-6 lg:grid-cols-12">
          <Reveal className="relative min-h-[360px] overflow-hidden rounded-[2rem] border border-[var(--gold)]/25 lg:col-span-7 lg:min-h-[520px]">
            <iframe data-testid="location-map" title="Mappa AURA" src={`https://maps.google.com/maps?q=${q}&z=16&output=embed`} loading="lazy" className="absolute inset-0 h-full w-full [filter:grayscale(.5)_sepia(.25)_contrast(.95)]" />
          </Reveal>
          <Reveal delay={0.1} className="flex flex-col justify-between gap-10 rounded-[2rem] bg-[var(--ink)] p-8 text-[var(--cream)] md:p-10 lg:col-span-5">
            <div className="space-y-8">
              <div className="flex gap-4">
                <MapPin className="mt-1 shrink-0 text-[var(--gold)]" size={20} />
                <div data-testid="location-address">
                  <p className="font-display text-2xl">{fullAddress(s)}</p>
                  {s.location_notes && <p className="mt-2 text-sm text-[var(--nude)]">{s.location_notes}</p>}
                </div>
              </div>
              <div className="flex gap-4">
                <Clock className="mt-1 shrink-0 text-[var(--gold)]" size={20} />
                <p data-testid="location-hours" className="whitespace-pre-line leading-relaxed text-[var(--cream)]/90">{s.hours}</p>
              </div>
            </div>
            <div className="space-y-6">
              <a data-testid="location-directions-button" href={MAP_LINK} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 rounded-full bg-[var(--gold)] py-4 text-sm font-medium text-[var(--ink)] transition-colors duration-300 hover:bg-[var(--cream)]">
                <Navigation size={16} /> Indicazioni stradali
              </a>
              <div data-testid="social-connect-section" className="flex items-center justify-between border-t border-white/10 pt-6">
                <p className="text-xs uppercase tracking-[0.28em] text-[var(--nude)]">Seguici</p>
                <SocialLinks s={s} />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
